export interface CouponState {
  coupons: Coupon[] | null;
  couponExternalGroups: CouponGroupExternal[] | null;
  appliedCoupons: AppliedCoupon[] | null;
  appCouponKey: string | null;
  appCoupons: AppCoupon[];
  unselectedAppCoupons: string[] | null;
  selectedAppCoupons: AppCoupon[] | null;
  remainingSlot: number;
}

export interface AppliedCoupon {
  uuid: string;
  code: string;
  menuName?: string;
  menuCode?: string;
  isAppCoupon: boolean;
  isTotalCoupon: boolean;
  isFreeCoupon: boolean;
}

export interface Coupon {
  id: number;
  code: string;
  name: string;
  discount: number;
  discountRate: number;
  imageUrl: string;
  expirationDate: Date;
  isFreeCoupon: boolean;
}

export interface CouponGroupExternal {
  parentCode: string;
  name: string;
  imageUrl: string;
  endAvailableDate: string;
  coupons: CouponExternal[];
}

export interface CouponExternal {
  code: string;
  kind: CouponType;
  name: string;
  imageUrl: string;
  isFreeCoupon: boolean;
  isTotalCoupon: boolean;
  menu: CouponMenu | null;
}

export interface CouponMenu {
  id: number;
  name: string;
  code: string;
  imageUrl: string;
  price: number;
  priceWithTax: number;
}

export interface AppCoupon {
  code: string;
  name: string;
  menuCode: string | null;
  isFreeCoupon: boolean;
  kind: number;
}

export enum CouponType {
  Normal = 0,
  App = 1,
  Limited = 2,
  NormalMulti = 3,
  AppMulti = 4,
  LimitedMulti = 5,
}

export type MenuExternalCoupon = CouponMenu & {
  quantity: number;
  couponCode: string;
  isFreeCoupon: boolean;
};
